@if (showToolbar) {
  <mat-toolbar color="primary" class="toolbar">
    <span class="logo">Private Lending Strategies</span>
    <span class="spacer"></span>
    <a mat-button routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
    <a mat-button routerLink="/contacts" routerLinkActive="active">Contacts</a>
    <a mat-button routerLink="/banks" routerLinkActive="active">Banks</a>
    <a mat-button routerLink="/insurance" routerLinkActive="active">Insurance</a>
    @if (showUsers()) {
      <a mat-button routerLink="/users" routerLinkActive="active">Users</a>
    }
    
    <!-- User menu -->
    <button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu-button" matTooltip="User Menu">
      <mat-icon>account_circle</mat-icon>
    </button>
    
    <mat-menu #userMenu="matMenu">
      <div class="user-menu-item">{{getEmail()}}</div>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </mat-toolbar>
}
<router-outlet></router-outlet>
